<template>
  <v-card style="width: 100%; height: 100%;">
    <v-tabs style="width: 100%; height: 100%;">
      <v-tab ripple active-class="activeTab"><span>Engine Faults</span></v-tab>
      <v-tab ripple active-class="activeTab"><span>Maintenance Tasks</span></v-tab>
      <v-tab-item style="width: 100%; height: 100%;">
        <v-container alert_container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
          <v-layout column fill-height>
            <v-layout row style="padding-top:15px;">
              <dx-data-grid
                  id="alertTable"
                  ref='alTable'
                  :data-source="alerts"
                  :selection="{ mode: 'single' }"
                  :show-column-lines="true"
                  :show-row-lines="true"
                  :show-borders="false"
                  :word-wrap-enabled="true"
                  :row-alternation-enabled="false"
                  :column-auto-width="true"
                  @selection-changed="setSelected">
                <dx-paging/>
              </dx-data-grid>
            </v-layout>
            <v-layout row style="max-height:50px;padding-left:20px;">
              <v-btn v-if="selected" flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="openFault()">
                Open Fault
              </v-btn>
              <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="dismissSelected()">
                Dismiss Selected
              </v-btn>
              <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="dismissAll()">
                Dismiss All
              </v-btn>
              <v-spacer/>
            </v-layout>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item style="width: 100%; height: 100%;">
        <v-container alert_container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
          <v-layout column fill-height>
            <v-layout row style="padding-top:15px;">
              <dx-data-grid
                  id="alertTable"
                  ref='alTable'
                  :data-source="tasks"
                  :selection="{ mode: 'single' }"
                  :show-column-lines="true"
                  :show-row-lines="true"
                  :show-borders="false"
                  :word-wrap-enabled="true"
                  :row-alternation-enabled="false"
                  :column-auto-width="true"
                  @selection-changed="setSelected">
                <dx-column
                    alignment="center"
                    data-field="Vessel"
                    caption="Vessel"
                />
                <dx-column
                    alignment="center"
                    data-field="Component"
                    caption="Engine"
                />
                <dx-column
                    alignment="center"
                    data-field="Component"
                    caption="Component"
                />
                <dx-column
                    alignment="center"
                    data-field="action"
                    caption="Action"
                />
                <dx-column
                    alignment="center"
                    data-field="c_rh"
                    caption="Current RH"
                />
                <dx-column
                    alignment="center"
                    data-field="pl_rh"
                    caption="Planned RH"
                />
                <dx-column
                    alignment="center"
                    data-field="pl_date"
                    caption="Planned Date"
                />
                <dx-column
                    alignment="center"
                    data-field="pr_rh"
                    caption="Prediction RH"
                />
                <dx-column
                    alignment="center"
                    data-field="pr_date"
                    caption="Prediction Date"
                />
                <dx-column
                    alignment="center"
                    data-field="acknowledged"
                    caption="Acknowledged"
                />
                <dx-column
                    alignment="center"
                    data-field="completed"
                    caption="Completed"
                />
                <dx-paging/>
              </dx-data-grid>
            </v-layout>
            <v-layout row style="max-height:50px;padding-left:20px;">
              <v-btn v-if="selected" flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="openFault()">
                Open Task
              </v-btn>
              <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="dismissSelected()">
                Dismiss Selected
              </v-btn>
              <v-btn flat style="color:white; background-color: rgb(51,82,128);height:30px;" @click="dismissAll()">
                Dismiss All
              </v-btn>
              <v-spacer/>
            </v-layout>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>Ø

<script>

import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

import {globalStore, vessels} from "../main.js"
import axios from 'axios'

export default {
  name: "Alerts",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling
  },
  data() {
    return {
      selected: false,
      selectedAlert: {},
    }
  },
  computed: {
    alerts: function () {
      var alerts = []

      if (globalStore.alerts.length) {
        globalStore.alerts
            .filter((item) => {
              return item.type == 'fault'
            })
            .map((i) => {
              let fault = Object.assign({}, i),
                  faultDatetime = (typeof i.faultDatetime.date == 'undefined' ? i.faultDatetime : i.faultDatetime.date);

              fault.faultDatetime = new Date(faultDatetime).toISOString().slice(0, 10);

              if (fault.Fault) {
                alerts.push(fault)
              }
            });
      }

      return alerts;
    },
    tasks: function () {
      var alerts = []

      if (globalStore.alerts.length) {
        globalStore.alerts
            .filter((item) => {
              return item.type == 'maintenance_task'
            })
            .map((i) => {
              alerts.push(i)
            });
      }

      return alerts;
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    setSelected({selectedRowsData}) {
      const data = selectedRowsData[0];

      this.selected = true;
      this.selectedAlert = data;
    },
    dismissAll() {
      axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: []}, {headers: {Authorization: globalStore.auth_token}}).then(() => {
        globalStore.alerts = [];
        this.selected = false;
        this.selectedAlert = {};
      }).catch(() => {
        globalStore.alerts = [];
        this.selected = false;
        this.selectedAlert = {};
      });
    },
    dismissSelected() {
      axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: [this.selectedAlert]}, {headers: {Authorization: globalStore.auth_token}}).then((respons) => {
        globalStore.alerts = respons.data.data;
        this.selected = false;
        this.selectedAlert = {};
      }).catch(() => {
      });
    },
    openFault() {
      if (this.selected) {
        let url = new URL(window.location.origin);

        if (this.selectedAlert.type == 'fault') {
          var vesselList = Object.values(vessels.vessels),
              vess = vesselList.find(vessel => vessel.name == this.selectedAlert.Vessel);

          globalStore.alertDate = this.selectedAlert.faultDatetime.slice(0, 10);
          globalStore.notificationId = this.selectedAlert.notification;

          url.pathname += `engine-faults/${this.selectedAlert.Vessel}`

          if (vess.has_twin) {
            url.pathname += `/engine/${this.selectedAlert.faultEngine}`
          }

          url.pathname += `/on/${globalStore.alertDate}/fault/${this.selectedAlert.Id}`

        } else if (this.selectedAlert.type == 'maintenance_task') {
          url.pathname += `maintenance-tasks/${this.selectedAlert.Vessel}/notification/${this.selectedAlert.id}`;
        }

        this.$router.push(url.pathname.toString());
      }
    },
  },
  watch: {}
}

</script>

<style scoped>
.alert_container .dx-row:hover {
  background-color: rgb(240, 240, 240);
}

#alertTable {
  font-size: 16px;
  font-family: 'Roboto', 'sans seriff';
  height: 100% !important;
}
</style>

<style>
.alert_container .dx-data-row:hover {
  background-color: rgb(240, 240, 240);
  cursor: pointer;
}
</style>
